import Select from 'components/shared/base_react_select'

const I18n = window.I18n

export default ({options, selected, handleChange}) => {
  const onChange = (opts) => handleChange('locations', opts)

  return (
    <div className="location-filter">
      <Select 
        isMulti
        value={selected}
        options={options}
        onChange={onChange}
        placeholder={I18n.t('activerecord.models.location.other')}
      />
    </div>
  )
}